// extracted by mini-css-extract-plugin
export default {"ThemeSwitch":"ThemeSwitch_ThemeSwitch__t3CRZ","dark":"ThemeSwitch_dark__oE0nJ","Toggle":"ThemeSwitch_Toggle__HHLwT"};